import { institutionsConstants } from "../constants/action.constants";

const initialState = {
  submitting: false,
  submitted: false,
  request: null,
  response: null,
  error: null
};

export const addInstitution = (state = initialState, action) => {
  switch (action.type) {
    case institutionsConstants.ADD_INSTITUTION_REQUEST:
      return {
        ...state,
        submitting: true,
        submitted: false,
        request: action.requestBody,
        response: null,
        error: null
      };
    case institutionsConstants.ADD_INSTITUTION_SUCCESS:
      return {
        ...state,
        submitting: false,
        submitted: true,
        response: action.response,
        error: null
      };
    case institutionsConstants.ADD_INSTITUTION_FAILURE:
      return {
        ...state,
        submitting: false,
        submitted: false,
        response: null,
        error: action.error
      };
    case institutionsConstants.ADD_INSTITUTION_RESET:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
